/* tcr.preferences.js - manage site user preferences - country, method, etc

Preferences are stored as follows - longest term first:
	Account - Customer attribute (not used yet)
    Cookies - client (may be disabled)
    Cart Attributes - server. Used by Liquid to render pages. Don't use from JS
    JS variable - client

    Page load/init - preference value get sequence
    - get value from cookie
    - if none - get value from Cart
    - if none - set a default
    - Set JS with value
    - Set menu/HTML elements
    - Trigger change

    Preference set/save sequence
    - Set JS
    - Set Cookie
    - Set Cart isJSONString
    - Trigger change
    
Changes
	1.1 - 6-18 May - added defaults for buildLocationCartAttributes(). Stopped tracking closeMenu
    9 July - Fixed Fav ID problem and "Saved as a favourite.."
    23 July - Fixed TrackLink problem
    22 October - Added Grind to product page
    16 November - changed h3 to p class=h3 for SEO
    9 Dec - fixed asset_url problem. Used abc?
    17 Feb 2018 - Added alt to images
    
*/
TCR.preferences = (function() {
  
  LTK.logHide.push( 'TCR.preferences' );	// Hide all these log messages

  var USER_ERROR_MESSAGE = "Sorry, something went wrong. We have been notified of the problem";
  
  // EXTERNAL functions
  function tcrTrack( event, eventProps ) { TCR.analytics.tcrTrack(event, eventProps); };
  function tcrLinkProperties( element ) { TCR.analytics.tcrLinkProperties( element ); };
  function tcrTrackOpenMenu( ui ) { TCR.analytics.tcrTrackOpenMenu( ui ); };
  function tcrTrackCloseMenu( ui ) { TCR.analytics.tcrTrackCloseMenu( ui ); };
  function log(text) { TCR.log(text); };
  function info(text) { TCR.info(text); };
  function warning(text) { 
    TCR.warning(text);
    //message( USER_ERROR_MESSAGE );
    //throw(text);
  };
  function error(text) { TCR.error(text); throw(text); };
  function message(text) { TCR.message(text); };
  function closeMessage() { TCR.closeMessage(); };
  function isBlank( obj ) { return LTK.isBlank( obj ); };
  function notBlank( obj ) { return LTK.notBlank( obj ); };
  function isJSONString( s ) { return LTK.isJSONString( s ); };
  function isValidJSONString( s ) { return LTK.isValidJSONString( s ); };
  function buildIconBlock( icon_file, icon_text, text_class ) { return TCR.buildIconBlock( icon_file, icon_text, text_class ); };
  function buildIconInline( icon_file, icon_text, text_class ) { return TCR.buildIconInline( icon_file, icon_text, text_class ); };
  function getCartAttributes( callback ) { return TCR.shopify.getCartAttributes( callback ); };
  function updateCartAttributes( attributes, callback ) {
    return TCR.shopify.updateCartAttributes( attributes, callback );
  };
  function addCartItem( variant_id, quantity, callback ) {
    return TCR.shopify.addCartItem( variant_id, quantity, callback );
  };
  function buildLocation(country) { return TCR.location.buildByCountry(country); };
  function parseLocation( locn_json ) { return TCR.location.parse( locn_json ); };
  function getCart(callback) { return TCR.shopify.getCart(callback); };
  function getFlagImage(country) { return TCR.location.getFlagImage(country); };
  function getShopifyCart(callback) { return TCR.shopify.getShopifyCart(callback); };
  
  var COOKIES_ENABLED = LTK.cookiesEnabled();
  var COUNTRY_MAP = TCR.location.country_map;

  var MOD = "TCR.preferences.";
  //log( MOD + "JS..." );

  var DOM_ID = ".preferences";	// DOM ID where prefs are shown

  //	Gather those Beans
  
  var GTB = {
    add_to_cart_msg_box: '#add-to-cart-msg-box',

    collected: {
      items: [],
      items_attribute: "gtb-items",
      quantity: 0,	// Amount of beans collected
      quantity_attribute: "gtb-collected"
    },
    elements: {
      header: 	".bellows__item.gtb-bag .bellows__header",
      found: ".gtb-found",
      message: ".gtb-message",
      quantity: ".gtb-quantity"
    },
    bag_icon: "coffee-bag_thumb.png",
    bag_full_icon: "coffee-bag-full_thumb.png",
    beans_icon: "gtb_thumb.png",
    item_quantity: 15,
    full_quantity: 30		// Change in tcr-coffee-bag.liquid as well
  };
  
  var FAVOURITES = {
    //Used when NOT a favourite
    cleared_icon: Shopify.ASSET_URL.replace( 'abc?', 'heart-grey.png?' ),
    elements: {
      content:	".bellows__item.favourites .tcr-bellows-content",
      header: 	".bellows__item.favourites .bellows__header",
      message: ".favourites-message",
      quantity: ".favourites-quantity"
    },
    icon: Shopify.ASSET_URL.replace( 'abc?', 'heart-orange.png?' ),
    //Used when IS a favourite
    set_icon: Shopify.ASSET_URL.replace( 'abc?', 'heart-orange.png?' )
  };

  // Cart attribute names - Will show in Shopify Admin in Order

  var MILK = "milk";
  var METHOD = "method";
  var GRIND = "grind";
  var LOCATION = "location";
  var PRODUCT_FAVS = "product_favs";
  var ROASTER_FAVS = "roaster_favs";
  

  var WHOLE_BEANS = "Whole Beans";
  var GROUND = "Ground";

  // Naming:
  //	PREFERENCES - Set of preference objects (preference)
  //	preference - single preference object
  //	current_pref: preference.current - e.g. Espresso. Value seen by user
  //	cart_pref: preference stored in cart
  //	cookie_pref: preference stored in cookie
  
  var PREFERENCES = {
    product_favs: {
      attribute: "product-favourites",
      cookie: "tcr_product_favs",
      current: {},
      default: "{}",		// JSON string
      element: 	".product-fav",
      inCart: function( cart ) {
        return cart.attributes[ this.attribute ]; // returns '' if not valid
      },
      isSet: function( fav_id ) {
        return notBlank( this.current[ fav_id ] );
      }
    },
    roaster_favs: {
      attribute: "roaster-favourites",
      cookie: "tcr_roaster_favs",
      current: {},
      default: "{}",
      element: 	".roaster-fav",
      inCart: function( cart ) {
        return cart.attributes[ this.attribute ]; // returns '' if not valid
      },
      isSet: function( fav_id ) {
        return notBlank( this.current[ fav_id ] );
      }
    },
    location: {
      attributes: {
        country: "delivery-country", /* name of cart delivery country attribute */
        couriers: "location-delivery-couriers", /* couriers who deliver to current location */
        location: "tcr-location", /* name of cart attribute - JSON */
        zone: "delivery-zone" /* name of cart delivery zone attribute */
      },
      change_event: "locationchanged", // event
      cookie: "tcr_location",
      current: "",		// Current country
      default: "United Kingdom",
      elements: {
        content: 	".preferences .bellows__item.location .tcr-bellows-content",
        header: 	".preferences .bellows__item.location .bellows__header",
        item: 		".preferences .bellows__item.location .bellows__content .item",
        menu:		".preferences .bellows__item.location"
      },
      geo_service: "//ip-api.com/json",
      inCart: function( cart ) {
        return cart.attributes[ this.attributes[ 'country' ] ]; // returns '' if not valid
      },
      isBlank: function( ) {
      	return isBlank( this.current );
      },
      save_event: "locationsaved",
      setJSCookie: function( tcr_location ) {		// Set current Location in JS & Cookie. Validate first
        setLocationJSCookie( tcr_location );
      }

    },
    milk: {
      attribute: "preferred-milk",
      change_event: "milkchanged", // event
      cookie: "tcr_milk",
      current: "",
      default: "Black",
      elements: {
        content: 	".preferences .bellows__item.milk .tcr-bellows-content",
        header: 	".preferences .bellows__item.milk .bellows__header",
        item: 		".preferences .bellows__item.milk .bellows__content .item",
        menu:		".preferences .bellows__item.milk"
      },
      inCart: function( cart ) {
        return cart.attributes[ this.attribute ]; // returns '' if not valid
      },
      isBlank: function( ) {
      	return isBlank( this.current );
      },
      options: {
        "Black": {
          file: 'tag-black_thumb.png'
        },
        "With milk": {
          file: 'tag-with-milk_thumb.png'
        },
        "Milky": {
          file: 'tag-milky_thumb.png'
        }
      },
      save_event: "milksaved",
      setJSCookie: function( milk ) {		// Set current Milk in JS & Cookie. Validate first
        setPreferenceJSCookie( MILK, milk );
      }
    },
    grind: {
      attribute: "preferred-grind",
      change_event: "grindchanged", // event
      cookie: "tcr_grind",
      current: "",
      default: "Whole Beans",
      elements: {
        content:	".preferences .bellows__item.grind .tcr-bellows-content",
        header: 	".preferences .bellows__item.grind .bellows__header",
        item: 		".preferences .bellows__item.grind .bellows__content .item",
        menu:		".preferences .bellows__item.grind"
      },
      ground: "Ground",
      whole_beans: "Whole Beans",
      inCart: function( cart ) {
      	return cart.attributes[ this.attribute ];
      },
      isBlank: function( ) {
      	return isBlank( this.current );
      },
      options: {
        "Whole Beans": {
          file: 'whole-beans_thumb.png'
        },
        "Ground": {
          file: 'grinder_thumb.png'
        }
      },
      save_event: "grindsaved" // event
    },
    method: {
      attribute: "preferred-method",
      change_event: "methodchanged", // event
      cookie: "tcr_method",
      current: "",
      default: "All methods",
      elements: {
        content: 	".preferences .bellows__item.method .tcr-bellows-content",
        header: 	".preferences .bellows__item.method .bellows__header",
        item: 		".preferences .bellows__item.method .bellows__content .item",
        menu:		".preferences .bellows__item.method"
      },
      inCart: function( cart ) {
      	return cart.attributes[ this.attribute ];
      },
      isBlank: function( ) {
      	return isBlank( this.current );
      },
      options: {
        "All methods": {
          file: 'tag-all-methods_thumb.png'
        },
        "Espresso": {
          file: 'tag-espresso_thumb.png'
        },
        "Cafetiere": {
          file: 'tag-cafetiere_thumb.png'
        },
        "Aeropress": {
          file: 'tag-aeropress_thumb.png'
        },
        "Filter": {
          file: 'tag-filter_thumb.png'
        }
      },
      save_event: "methodsaved" // event
    }
  };
 
  //	Return current location as a JS object
  function currentLocation() {
     return buildLocation( PREFERENCES.location.current );
  };
  function currentLocationJSON() {
     return JSON.stringify( currentLocation() );
  };
  
  //	Return the current preferences as a text string
  function currentPreferenceText() {
    return PREFERENCES.method.current + 
      " " + PREFERENCES.milk.current + 
      " available to " + PREFERENCES.location.current;
  };

  //	Return the preference object given a type. Error if not valid type
  
  function getPreference( type ) {
    var fn = MOD + "getPreference() ";
    var preference = PREFERENCES[ type ];
    
    if( isBlank( preference ) ) {
      error( fn + "Preference type (" + type + ") is not valid" );
      return "";
    }
    return preference;
  };
  
  //	isPreferenceValid() - pref is a string
  function isPreferenceValid( type, pref ) {
    var fn = MOD + "isPreferenceValid() ";
    
    var preference = getPreference( type );
    if ( preference == "" ) return false;
    
    //log( fn + type + ": " + pref );
    //log( fn + "Method [" + method + "], METHODS[ method ]: " + METHODS[ method ]);
    //log( fn + notBlank( PREFERENCES[ type ].options[ pref ] ));
    if ( type == LOCATION ) {
      return notBlank( buildLocation( pref ) );
      
    } else if ( type == PRODUCT_FAVS || type == ROASTER_FAVS ) {
      return isValidJSONString( pref );
      
    } else {	// Normal preference
      return notBlank( preference.options[ pref ] );
      
    }
  };

  function isMethodValid( method ) {
    return isPreferenceValid( METHOD, method );
  };
  
  function isGrindValid( grind ) {
    return isPreferenceValid( GRIND, grind );
  };

  function isMilkValid( milk ) {
    return isPreferenceValid( MILK, milk );
  };

  function setPreferenceJS( type, tobe ) {
    var fn = MOD + "setPreferenceJS() ";

    //log( fn + "..." );
    var preference = getPreference( type );
    if ( preference == "" ) return false;

    //if( ! isPreferenceValid( type, tobe ) ) {
    //  warning( fn + "Invalid " + type + " Preference : [" + tobe + "]" );
    //  return "";
    //}
    //	Assumption - if current == object then no change event and so just set it
    //	else if current != tobe then set and trigger change event
    
    if( typeof( preference.current ) == "object") {
      if( isBlank( tobe ) ) {
        preference.current = {};
      } else {
        try {
          preference.current = $.parseJSON( tobe );
        } catch (err) {
          preference.current = {};
          warning( fn + "Couldn't parse JSON: [" + tobe + "]" );
          //$( "body" ).trigger( preference.change_event, [ preference.current ] );
        };
      }
      //log( fn + type + ": " + JSON.stringify( preference.current ) );

    } else if ( preference.current != tobe ) {
      //log( fn + "current [" + preference.current + "] to be [" + tobe + "]" );

      preference.current = tobe;
      //log( fn + type + ": " + preference.current + ", TRIGGER: " + preference.change_event );
      $( "body" ).trigger( preference.change_event, [ preference.current ] );
    }
    return preference.current;
  };

  function setPreferenceCookie( type, tobe ) {
    var fn = MOD + "setPreferenceCookie() ";
    //log( fn + "..." );

    var preference = getPreference( type );
    if ( preference == "" ) return false;

    if( COOKIES_ENABLED ) {
      var current_cookie = $.cookie(preference.cookie);
      if ( current_cookie != tobe ) {
        // Save cookie
        current_cookie = $.cookie(preference.cookie, tobe, { expires: 200, path: '/' });
        //log( fn + type + ": " + current_cookie );
        //log( fn + type + ": " + current_cookie );
      }
      return current_cookie;
    } else {
      log( fn + "Cookies NOT enabled. " + type + " tobe: " + tobe );
      //log( fn + type + ": nil" );
      return "";
    }
  };

  function buildLocationCartAttributes( country ) {
    var fn = MOD + "buildLocationCartAttributes() ";
    
    log( fn + "...Country: " + country );

    var attributes = [];
    
    var tcr_location = buildLocation( country );
    //	Set some default values
    var zone = "United Kingdom"
    var couriers = '["Courier UK","RM United Kingdom","Royal Mail UK"]';
    
    //log( fn + "tcr_location: " + JSON.stringify( tcr_location ) );
    
    if ( notBlank( tcr_location ) ) {
      country = tcr_location.country;
      zone = tcr_location.country_zone;
      couriers = tcr_location.couriers.toString();
      attributes.push( { key: PREFERENCES.location.attributes.location, value: JSON.stringify( tcr_location ) } );
    }
    attributes.push( { key: PREFERENCES.location.attributes.country, value: country } );
    attributes.push( { key: PREFERENCES.location.attributes.zone, value: zone } );
    attributes.push( { key: PREFERENCES.location.attributes.couriers, value: couriers } );
    
    //log( fn + "Attributes: " + JSON.stringify( attributes ) );
    return attributes;

  };

  
  //	setPreferenceCart() - sets a single preference in the cart if it needs to
  //		May wait for cart to be returned
  
  function setPreferenceCart( type, tobe ) {
    var fn = MOD + "setPreferenceCart() ";

    //log( fn + "..." );
    var preference = getPreference( type );
    if ( preference == "" ) return false;
    
    getCartAttributes( function( current_attributes ) {
      if ( typeof(current_attributes) === 'undefined' ) {
        error( fn + "Current Cart Attributes not provided" );
        return;
      }
      
      var current_pref = current_attributes[ preference.attribute ];
      
      if( current_pref == tobe ) {
        
        closeMessage();
        
      } else {
        var cart_updates = [];
        // Save Preference Cart attribute
        log( fn + "Saving " + type + ": " + tobe + " in cart...");
        
        if ( type == LOCATION ) {
          jQuery.each( buildLocationCartAttributes( tobe ), function( index, attribute ) {
          	cart_updates.push( attribute );
          });
        } else {
          cart_updates.push( { key: preference.attribute, value: tobe } );
        }

        updateCartAttributes( cart_updates,
          function( cart ) {
            if ( typeof( cart ) === 'undefined' ) {
              error( fn + "Cart argument is not provided" );
              return;
            }

            var new_pref = preference.inCart( cart );
            if( isBlank( new_pref ) ) {
              warning( fn + "Could not set preference '" + tobe + "' in Cart");
              return;
              
            } else {
              //log(fn + type + ": " + new_pref );
              $( "body" ).trigger( preference.save_event, [ new_pref ]  );
              if( Shopify.template == "cart" ) {
                closeMessage();
              } else {
                closeMessage();
                //message("Getting coffees for " + currentPreferenceText() + "...");
                //location.reload();		// Reload current page
              }
            }

          });
        //log( fn + "Sent updateCartAttributes AJAX request");
      }
    });

  };
  
  //
  // setPreference* - Sets a single preference in JS, Cookie and Cart
  //	setPreference is normally used on menu item Click
  //    Only triggers events if value actually changes
  //    'type' can be: method, milk, grind
  
  //	 Use syncPreferences to set multiple preferences
  //
  function setPreference( type, tobe ) {
    var fn = MOD + "setPreference() ";
    log( fn + type + ": " + tobe );

    if( ! isPreferenceValid( type, tobe ) ) {
      log( fn + "...NOT valid" );
      return "";
    }

    message( "Saving preference " + tobe + "...");
    
    setPreferenceJS( type, tobe );
    setPreferenceCookie( type, tobe );
    setPreferenceCart( type, tobe );
  };


  
  // Return the <img> element for a preference.
  function buildImg( type, pref ) {
    var fn = MOD + "buildImg() ";
    //log( fn + type + ": " + preference );

    var preference = getPreference( type );
    if ( preference == "" ) return false;

    if( type == LOCATION ) {
      return getFlagImage( pref );
      
    } else {
      var file;

      if ( notBlank( preference.options[ pref ] ) ) {
        file = preference.options[ pref ].file;
        if ( notBlank( file ) ) {
          return '<img class="icon" src="' + Shopify.ASSET_URL.replace( 'abc?', file + '?') + '" alt="' + pref + '" />'
        }
      }
    }
  };

  //
  //	syncPreferences( cart ) - sync across JS, Cookie & Cart - updating as needed
  //	Gets called when cart is available
  //	Cart is assumed as master
  //	For each preference
  //		Get value from Cart
  //		If valid then set JS & Cookie
  //		Else 
  //			Set current preferences in JS and cookie. Get info from cookies
  //			get a valid value (cookie or default) and queue update to cart
  //
  function syncPreferences( cart ) {
    var fn = MOD + "syncPreferences() ";

    //log( fn + "...");

    if( typeof( cart ) === "undefined" ) {
      error( fn + "cart has not been provided" );
      return;
    };

    var cart_updates = [];

    jQuery.each(PREFERENCES, function (type, preference) {
      //	Skip to next if no change event - i.e. not a preference
      //if( isBlank( preference.change_event ) ) return true;

      var tobe_pref = null;
      var cart_pref = preference.inCart( cart );  // Could be: blank, OK, invalid JSON or valid JSON 
      
      //	Set tobe to cart if cart is valid
      if( isPreferenceValid( type, cart_pref ) ) {
        tobe_pref = cart_pref;
        log( fn + "Set TO-BE " + type + " from CART: " + tobe_pref );
      }
      //	Set tobe to current if current is valid
      if( tobe_pref == null && isPreferenceValid( type, preference.current ) ) {
        if ( typeof( preference.current ) == "object" ) {
          tobe_pref = JSON.stringify( preference.current ) 
        } else {	// Normal text preference
          tobe_pref = preference.current;
        }
        log( fn + "Set TO-BE " + type + " from CURRENT: " + tobe_pref );
      }
      //	Set tobe to cookie if cookies are enabled and is valid

      if( tobe_pref == null && COOKIES_ENABLED ) {
        var cookie_pref = $.cookie( preference.cookie );
        
        if( typeof(cookie_pref) === 'undefined' || isBlank( cookie_pref ) ) {
          //log( fn + type + " Cookie: " + preference.cookie + " doesn't exist" );
          tobe_pref = preference.default;
          log( fn + "Set TO-BE " + type + " from DEFAULT: " + tobe_pref );
        } else if ( ! isPreferenceValid( type, cookie_pref ) ) {
          //info( fn + type + " Cookie [" + cookie_pref + "] isn't valid" );
          tobe_pref = preference.default;
          log( fn + "Set TO-BE " + type + " from DEFAULT: " + tobe_pref );
        } else {
          //log( fn + "Got " + type + " from cookie: " + cookie_pref );
          tobe_pref = cookie_pref;
          log( fn + "Set TO-BE " + type + " from COOKIE: " + tobe_pref );
        }
      }
      //	Now have a tobe.  If not the same as the cart, push for update
      if( tobe_pref != cart_pref ) {
		// Push tobe onto updates for cart
        if( type == LOCATION ) {
          jQuery.each( buildLocationCartAttributes( tobe_pref ), function( index, attribute ) {
          	cart_updates.push( attribute );
          });
        } else { // if ( notBlank( tobe_pref ) ) {
          //log( fn + "cart update: " + type + " tobe: " + tobe_pref );
          cart_updates.push( { key: preference.attribute, value: tobe_pref } );
        }
      }
      setPreferenceJS( type, tobe_pref );
      setPreferenceCookie( type, tobe_pref );
      
      //log( fn + type + " Handle Product page grind/method...");  
      if ( type == GRIND ) {
        if( tobe_pref == "Ground") {
        	//log( fn + "Pref: " + type + " ,Show to be:" + tobe_pref );  
        	$( ".product-page.method" ).show();
      	} else {
        	//log( fn + "Pref: " + type + " ,Hide to be:" + tobe_pref );  
        	$( ".product-page.method" ).hide();
        }
      }


    });

    //	Update Cart Attributes if any preferences need updating
    log( fn + cart_updates.length + " Cart updates: " + JSON.stringify( cart_updates ) )
    if( cart_updates.length > 0 && true ) {
      updateCartAttributes( cart_updates, function( cart ) {
        if( Shopify.template == "cart" ) {
          closeMessage();
        } else {
          //message("Getting coffees for " + currentPreferenceText() + "...");
          //location.reload();		// Reload current page
        }
      });
    }

    log( fn + "...OK");

  };

  function gtbMessage( text ) {
    jQuery( GTB.elements.message ).html( text );
  };

  
 //   refreshGTBBag() refresh the bag icon and quantity

  function refreshGTBBag(){
    var fn = MOD + "refreshGTBBag() ";

    var html='<div class="block m-auto icon" title="Find the hidden beans and get free coffee">';
    var icon_file="";
    var quantity="";
    
    if( GTB.collected.quantity == 0 ) {
      icon_file = GTB.bag_icon;
      quantity = "Empty";
      
    } else if ( GTB.collected.quantity >= GTB.full_quantity ) {
      icon_file = GTB.bag_full_icon;
      quantity = "Full";
    } else {
      icon_file = GTB.bag_icon;
      quantity = GTB.collected.quantity + "g";
    }
    
    html += '<img class="icon" src="' +
      Shopify.ASSET_URL.replace( 'abc?', icon_file + '?') + '" alt="' + icon_file + '" />';
    
    html += '</div>';
    html += '<span class="hidden">GTB Bag - </span>';	// For tracking
    html += '<div class="grid-item w-auto gtb-quantity">';
    //html += quantity;
    html += '</div>';
    //log( fn + "html:" + html );
    
    if ( GTB.collected.quantity == 0 ) {	// Dont show if empty
      html="";
      quantity="";
    }
    jQuery( GTB.elements.header ).html( html );
    jQuery( GTB.elements.quantity).html( quantity );

  };

  function gtbAddReward(){
    var fn = MOD + "gtbAddReward() ";

    if( typeof( Shopify.gtb_reward_id ) !== 'undefined' &&
       Shopify.gtb_reward_id != 0 ) {

      getCart( function( cart ) {

        var reward_in_cart = false;

        jQuery.each( cart.items, function( key, item ) {
          if ( item.id == Shopify.gtb_reward_id ) {
            reward_in_cart = true;
          }
        });
        //	Add reward to cart if not in there
        if( ! reward_in_cart ){
          addCartItem(Shopify.gtb_reward_id, 1, function( line_item ) {
            info( fn + "Added GTB reward to cart" );
            getShopifyCart( function( cart ) {
              // 
              log( fn + "Got cart after add" );
              $( GTB.add_to_cart_msg_box ).show();
            });
          });
        }
      });
    }
  };

  //	clearGTBBag() - Clear the quantity & collected items from the cart & refresh
  
  function clearGTBBag(){
    var fn = MOD + "clearGTBBag() ";
	log( fn + "..." );
    GTB.collected.quantity=0;
    GTB.collected.items=[];
    
    updateCartAttributes(
      [
        { key: GTB.collected.quantity_attribute, value: GTB.collected.quantity },
        { key: GTB.collected.items_attribute, value: JSON.stringify( GTB.collected.items ) }
      ],
      function( cart ) {
        //refreshGTBBag();	// No need to refresh - this gets done when cart is received
        log( fn + "...OK" );
      }
    );

  };

  function gatherTheBeans(){
    var fn = MOD + "gatherTheBeans() ";
    
    log( fn + "..." );
    
    if( GTB.collected.quantity > 0) {
      gtbMessage("Gathering the beans...");
    }
    //	Add the gathered beans to the cart attributes
    updateCartAttributes(
      [
        { key: GTB.collected.quantity_attribute, value: GTB.collected.quantity },
        { key: GTB.collected.items_attribute, value: JSON.stringify( GTB.collected.items ) }
      ],
      function( cart ) {

        if ( GTB.collected.quantity >= GTB.full_quantity ) {	// Bag is full
          gtbMessage( "Hurrah! - your bag is full" + "<br/>" +
                     "Go to the checkout to claim your free bag of coffee" );

          //	Bag is full - check the cart and add reward if not there
          GTB.collected.quantity = GTB.full_quantity;
          gtbAddReward();
        } else if( GTB.collected.quantity > 0) {
          
          gtbMessage( "Hurrah! - you've added " +
                     GTB.item_quantity + "g to your bag" );
        }
      }
    );
  };

    //	setFavouriteIcon() - Set the Favourite icon (to orange) for product
  function setFavouriteIcon( fav_id ) {
    var fn = MOD + "setFavouriteIcon() ";

    //log( fn + "id: " + fav_id );
    jQuery( ".product-fav[data-fav-id='" + fav_id + "']" )
    	.attr( 'src', FAVOURITES.set_icon );
    jQuery( ".roaster-fav[data-fav-id='" + fav_id + "']" )
    	.attr( 'src', FAVOURITES.set_icon );
  }

  function clearFavouriteIcon( fav_id ) {
    var fn = MOD + "clearFavouriteIcon() ";

    //log( fn + "id: " + fav_id );
    jQuery( ".product-fav[data-fav-id='" + fav_id + "']" )
    	.attr( 'src', FAVOURITES.cleared_icon );
    jQuery( ".roaster-fav[data-fav-id='" + fav_id + "']" )
    	.attr( 'src', FAVOURITES.cleared_icon );
  }
  
  function updateFavouritesInCart() {		// And in cookies
    var fn = MOD + "updateFavouritesInCart() ";
    
    log( fn + "..." );
    
    setPreferenceCookie( PRODUCT_FAVS, JSON.stringify( PREFERENCES.product_favs.current ) );
    setPreferenceCookie( ROASTER_FAVS, JSON.stringify( PREFERENCES.roaster_favs.current ) );

    updateCartAttributes(
      [
        { key: PREFERENCES.product_favs.attribute, value: JSON.stringify( PREFERENCES.product_favs.current )},
        { key: PREFERENCES.roaster_favs.attribute, value: JSON.stringify( PREFERENCES.roaster_favs.current )}
      ],
      function( cart ) {
        //log(fn + "Coffees: " + cart.attributes[ FAVOURITES.attribute ] );
      });
  };

  // set/clearFavourite - add/remove from current, set/clear icon & update cart
  //	Favourites are:
  //		coffees: {
  //			product_fav_id: { title: title, handle: handle }
  //		}

  function setFavourite( type, fav_id ) {
    var fn = MOD + "setFavourite() ";
    log( fn + "id: " + fav_id );
    
    var favourite = {};
    if( type == "product" ) {
      favourite.product_title = jQuery( ".product-fav[data-fav-id='" + fav_id + "']" ).first().attr( 'title' );
      favourite.product_handle = jQuery( ".product-fav[data-fav-id='" + fav_id + "']" ).first().attr( 'data-fav-handle' );

      if( isBlank( favourite.product_title ) || isBlank( favourite.product_handle ) ) {
        warning( fn + "Product title or handle is blank: " + JSON.stringify( favourite ) );
        return;
      }
      favourite.product_title = favourite.product_title.replace('Save as a favourite:','').trim();
      // Add Favourite if it doesn't already exist
      if( isBlank( PREFERENCES.product_favs.current[ fav_id ] ) ) {
        PREFERENCES.product_favs.current[ fav_id ] = favourite;
        //log( fn + fav_id + ": " + JSON.stringify( FAVOURITES.coffees[ fav_id ] ) );
      }

    } else {
      favourite.roaster_title = jQuery( ".roaster-fav[data-fav-id='" + fav_id + "']" ).first().attr( 'title' );
      favourite.roaster_url = jQuery( ".roaster-fav[data-fav-id='" + fav_id + "']" ).first().attr( 'url' );

      if( isBlank( favourite.roaster_title ) ) {
        warning( fn + "Roaster title is blank: " + JSON.stringify( favourite ) );
        return;
      }
      favourite.roaster_title = favourite.roaster_title.replace('Save as a favourite:','').trim();
      // Add Favourite if it doesn't already exist
      if( isBlank( PREFERENCES.roaster_favs.current[ fav_id ] ) ) {
        PREFERENCES.roaster_favs.current[ fav_id ] = favourite;
        //log( fn + fav_id + ": " + JSON.stringify( FAVOURITES.roasters[ fav_id ] ) );
      }
    }
    
    setFavouriteIcon( fav_id );
    updateFavouritesInCart();
  };
  
  function clearFavourite( type, fav_id ) {
    var fn = MOD + "clearFavourite() ";
    //log( fn + "id: " + product_fav_id );

    if( type == "product" ) {
      if( notBlank( PREFERENCES.product_favs.current[ fav_id ] ) ) {
        delete PREFERENCES.product_favs.current[ fav_id ];
      }
    } else {
      if( notBlank( PREFERENCES.roaster_favs.current[ fav_id ] ) ) {
        delete PREFERENCES.roaster_favs.current[ fav_id ];
      }
    }
    
    clearFavouriteIcon( fav_id );
    updateFavouritesInCart();
  };

  function toggleFavourite( type, fav_id, fav_handle, fav_title ) {
    var isSet;
    
    if( type == "product" ) {
      isSet = PREFERENCES.product_favs.isSet( fav_id );
    } else {
      isSet = PREFERENCES.roaster_favs.isSet( fav_id );
    }
    
    if( isSet ) {
      tcrTrack('Cleared favourite ' + type, {
          title : fav_title,
          handle : fav_handle,
          favourite_type: type,
          favourite_id: fav_id
      });
      clearFavourite( type, fav_id );
    } else {
      tcrTrack('Added favourite ' + type, {
          title : fav_title,
          handle : fav_handle,
          favourite_type: type,
          favourite_id: fav_id
      });
      setFavourite( type, fav_id );
    }
  };

  //	Display the Favourites Menu and current favourites
  
  function refreshFavourites(){
    var fn = MOD + "refreshFavourites() ";
    log( fn + "..." );

    var header_html = "";
    var coffee_html = "";
    var roaster_html = "";
    var coffee_favourites = 0;
    var roaster_favourites = 0;
    
    //	List the favourites
    jQuery.each( PREFERENCES.product_favs.current, function( fav_id, favourite ) {
      //log( fn + fav_id + ": " + JSON.stringify( favourite ) );
      coffee_favourites += 1;
      coffee_html += '<a class="body body-small" href="/products/' +
        favourite.product_handle + '">' +
        favourite.product_title + '</a><br/>';
    });
    
    jQuery.each( PREFERENCES.roaster_favs.current, function( fav_id, favourite ) {
      log( fn + fav_id + ": " + JSON.stringify( favourite ) );
      roaster_favourites += 1;
      if( typeof( favourite.roaster_url ) === 'undefined' || favourite.roaster_url == "" ) {
        roaster_html += '<span class="body body-small">' +
          favourite.roaster_title + '</span><br/>';
      } else {
        roaster_html += '<a class="body body-small" href="' + favourite.roaster_url + '"';
        // Open new page if not on our site
        if ( favourite.roaster_url.indexOf( 'collections' ) == -1 ) {
          roaster_html += ' target="_blank"'
        }
        roaster_html += '>' + favourite.roaster_title + '</a><br/>';
      }
    });

    if( roaster_favourites + coffee_favourites > 0 ) {
      header_html =  '<div class="block m-auto icon" title="My favourite coffees and roasters">';
      header_html += '<img class="icon" src="' + FAVOURITES.icon + '" alt="Favourite" />';
      header_html += '<span class="hidden">My Favourites - </span>';	// For tracking
      header_html += '</div>';
      header_html += '<div class="grid-item w-auto favourites-quantity"></div>';

      coffee_html = '<p class="center h3">My favourites</p>' + coffee_html;
    }
    jQuery( FAVOURITES.elements.header ).html( header_html );
    
    var content_html = coffee_html;
    if ( coffee_html != "" && roaster_html != "" ) {
      content_html += "<hr/>"
    }
    content_html += roaster_html;
    
    jQuery( FAVOURITES.elements.content ).html( content_html );
    
    jQuery( FAVOURITES.elements.quantity).html( roaster_favourites + coffee_favourites );
    
    //	Add track events for each of the favourites links
    analytics.trackLink( $(".favourites a"), 'Clicked Link', tcrLinkProperties );

    log( fn + "...OK" );

  };

  

  // Events - CART is available
  //	Trigged when cart is retrieved the first time for a page and after cart is updated
  //	- get preference attributes from cart
  //	- if JS & cookie need updating - update with cart values
  //	- if cart values != JS - update cart attributes (all at once)
  //	- Trigger Cart Update if needed
  
  $( "body" ).on( TCR.shopify.cart_available, function( event, cart ) {
    var fn = MOD + "EVENT:CART AVAILABLE: ";

    log( fn + "...");
    //log( fn + "cart: " + JSON.stringify( cart ) );
    syncPreferences( cart );

    // set favourites icons
    jQuery.each( PREFERENCES.product_favs.current, function( fav_id, favourite ) {
      setFavouriteIcon( fav_id );
    });
    jQuery.each( PREFERENCES.roaster_favs.current, function( fav_id, favourite ) {
      setFavouriteIcon( fav_id );
    });
	refreshFavourites();	// Show the Favourites menu
    
    // Get current GTB quantity and items
    if ( isBlank( cart.attributes[ GTB.collected.quantity_attribute ]) ) {
      GTB.collected.quantity = 0;
    } else {
      GTB.collected.quantity = parseInt(
        cart.attributes[ GTB.collected.quantity_attribute ]
      );
    }
    
    var collected_items = cart.attributes[ GTB.collected.items_attribute ];
    
    if ( notBlank( collected_items ) && isValidJSONString( collected_items ) ){
      try {
        GTB.collected.items = $.parseJSON( collected_items );
      } catch (err) {
        GTB.collected.items = {};
        warning( fn + "couldn't parse JSON: [" + collected_items + "]" );
      };

      //log( fn + "GTB.collected.items: " + JSON.stringify(GTB.collected.items) );
    }    
    
    //	Bag is full - limit collected quantity
    if ( GTB.collected.quantity >= GTB.full_quantity ) {
      GTB.collected.quantity = GTB.full_quantity;
    }
    refreshGTBBag();
    
    log( fn + "...OK");
  });
  

  /*
	Initialise Preference and favourite elements
    - Initialise menu/HTML elements
*/
  function initElements() {
    var fn = MOD + "initElements() ";

    //log( fn + "...");  

    // Init Preferences container
    $('.preferences').bellows( {
      opened: function(e, ui) { 
        tcrTrackOpenMenu( ui );
      },
      close: function(e, ui) { 
        //tcrTrackCloseMenu( ui );
      }
    } 
    );

    jQuery.each(PREFERENCES, function (type, preference) {
      
      //	Skip to next if no change event - i.e. not a preference
      if( isBlank( preference.change_event ) ) return true;

      // Init menu items
      //log( fn + type + " Menu items...");
      var header = "";

      if( type == MILK ) {
         header = "I prefer";
      } else if ( type == LOCATION ) {
         header = "Deliver to";
      } else {
         header = "My " + type;
      }
      var html = "<p class='center h3'>" + header + "</p>";

      //log( fn + JSON.stringify( pref ));
      if( type == LOCATION ) {
        
        jQuery.each(COUNTRY_MAP, function(country, zone) {

          html += '<div class="item m-b-5" location="' + country + '">';
          html += buildIconInline( getFlagImage( country ), country );
          html += '</div>';

        });

      } else {

        jQuery.each( preference.options, function(option_key, option) {
          //log( fn + type + ": " + option_key + " item");  
          html += '<div class="item m-b-5 pad-lr-5" ' + type + '="' + option_key + '">';
          html += buildIconInline( buildImg( type, option_key ), option_key );
          html += '</div>';
        });
      }
      jQuery( preference.elements.content ).append( html );
      //log( fn + type + " Menu items...OK");
      
      // Attach Click event to each Menu item

      //log( fn + type + " Attach Click event...");  
      $( preference.elements.item )
      .on("click", function(event) {
        var option = $(this).attr( type );
        var current_preference = PREFERENCES[type].current;
        setPreference( type, option );
        tcrTrack('Changed preference', {
          title : type + ": " + current_preference + " => " + option,
          preference_type: type,
          preference: option
        });
        $('.preferences').bellows('close', $( preference.elements.menu ));

      });

    });
    
    //	Gather Those Beans
    $( GTB.elements.found )
    .click( function(event) {
      var gtb_item_id = $( this ).attr( 'id' );
      if ( GTB.collected.items.indexOf( gtb_item_id ) == -1 ) {
        GTB.collected.items.push( gtb_item_id );
        GTB.collected.quantity += GTB.item_quantity;
        gatherTheBeans();
        //message("Gathered 10g of beans. Total: " + GTB.collected.quantity);
      } else {
        $(this).hide();
        //gtbMessage( "You have already gathered these beans " + gtb_item_id );
      }
    });
    //	Favourites
    $( PREFERENCES.product_favs.element )
    .click( function(event) {
      var fn = MOD + "CLICK: Product favourite: ";
      var fav_id = $( this ).attr( 'data-fav-id' );
      var fav_handle = $( this ).attr( 'data-fav-handle' );
      var fav_title = $( this ).attr( 'title' );
          fav_title = fav_title.replace('Save as a favourite:','').trim();
      
      toggleFavourite( "product", fav_id, fav_handle, fav_title );
    });
          
    $( PREFERENCES.roaster_favs.element )
    .click( function(event) {
      var fn = MOD + "CLICK: Roaster favourite: ";
      var fav_id = $( this ).attr( 'data-fav-id' );
      var fav_handle = $( this ).attr( 'data-fav-handle' );
      var fav_title = $( this ).attr( 'title' );
          fav_title = fav_title.replace('Save as a favourite:','').trim();
      
      toggleFavourite( "roaster", fav_id, fav_handle, fav_title );
    });
          
          

    log( fn + "...OK");  
  };



  // tcr.preferences - MAIN
  //	Attach Change handlers
  
  function main() {
    var fn = MOD + "main() ";

    //log( fn + "...");

     jQuery.each(PREFERENCES, function (type, preference) {
       
       //	Skip to next if no change event - i.e. not a preference
      if( isBlank( preference.change_event ) ) return true;

       
       // CHANGE EVENT handler - important to do this early so any JS changes are caught
       //	'pref' is the string/JSON of the preference
       
      $( "body" ).on( preference.change_event, function(event, pref) {
        var fn = MOD + "EVENT:" + type + " CHANGE: ";
        
        $( preference.elements.header ).html (
          buildIconBlock( buildImg( type, pref ), pref )
         );
        // Update tag select elements - select current preferences
          
          // Handle Product page grind/method
          if ( type == GRIND && preference.current == "Ground") {
          	//$( ".product-page.method" ).show();
          } else {
            //$( ".product-page.method" ).hide();
          }
         
          //console.log( fn + type + ":: " + preference.current);
      });
       
    });
    
    //log( fn + "...OK");
  }
  
  $(document).ready(function() {
    var fn = MOD + "doc() ";

    //log( fn + "DOM ready..." );

    initElements();
    
    //log( fn + "DOM ready...OK" );

  });
  
  main();

  //log( MOD + "JS...OK")
  //	Public methods

  return {
    currentPreferenceText: currentPreferenceText,
    clearGTBBag: clearGTBBag,
    
    grind: PREFERENCES.grind,

    isPreferenceValid: isPreferenceValid,
    setPreference: setPreference,

    location: PREFERENCES.location,
    currentLocation: currentLocation,	// Returns JS object of current

    method: PREFERENCES.method,
    
    milk: PREFERENCES.milk

    
  };

})();	// End of TCR.preferences Module - IFFE pattern